<script setup lang="ts">
import { useTagStore } from '~/stores/tag'

import type { Tag } from '~/entities/tag'
import type { Influencer } from '~/types/influencer'

type AvailableMarkType = 'free' | 'new'

type Props = {
  influencer: Influencer
}
const props = defineProps<Props>()

const { GET_TAGS_FROM_IDS } = useTagStore()

const availableMarks = ref<AvailableMarkType[]>([])
const markTags = ref<Tag[]>([])

const type = computed<AvailableMarkType | undefined>(() => {
  for (const markName of availableMarks.value) {
    const tag = markTags.value.find((tag) => tag.name === markName)

    if (tag) return markName as AvailableMarkType
  }
  return undefined
})

markTags.value = computeMarkTags()

function computeMarkTags(): Tag[] {
  return GET_TAGS_FROM_IDS(
    props.influencer.tags?.identity.influencer_mark ?? [],
  )
}
</script>

<template>
  <div
    v-if="type"
    class="tw-flex tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-xs tw-px-2 tw-py-1 tw-text-2xs tw-font-bold tw-uppercase tw-text-white"
    :class="{
      'tw-bg-[var(--color-cute)]': type === 'free',
      'tw-bg-[var(--color-param)]': type === 'new',
    }"
  >
    <span>{{ $t(`influencer.textBadge.${type}`) }}</span>
  </div>
</template>
